import { render } from "./index.vue?vue&type=template&id=df28db78&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=df28db78&lang=scss"
import "./index.vue?vue&type=style&index=1&id=df28db78&lang=scss&scoped=true"

import exportComponent from "/Users/arvindersingh/Desktop/projects/parsoftwares/rt-backend/backend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df28db78"]])

export default __exports__